import { useContext } from 'react';
import ModalContext from '~/contexts/ModalContext';

export default function BackgroundOverlay() {
  const { isSearchBarFocused } = useContext(ModalContext);

  return (
    <div
      className={`absolute bg-blue-7 opacity-0 duration-300 h-full left-0 top-0 transition-all pointer-events-none w-full z-[1] ${
        isSearchBarFocused ? 'opacity-20' : ''
      }`}
    />
  );
}
